module.exports = __webpack_public_path__ + "static/7-950964a76a057326a7766feae52a048f.png";